module.exports = __webpack_public_path__ + "img/vezapodorysy4NP.fd8e44d5.png";